import config from './config-nursingrobot'

export default config



// WEBPACK FOOTER //
// ./src/config/config.js